import { FC, useState } from 'react';
import { Column, Text } from '~/commonComponents';
import { Colors } from '~/themes/colors';

interface IProfessionTypeCardProps {
  icon: FC;
  label: string;
  isSelected: boolean;
  onClick: () => void;
}

export const ProfessionTypeCard: FC<IProfessionTypeCardProps> = ({
  icon: Icon,
  label,
  isSelected,
  onClick,
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const getBackgroundColor = () => {
    if (isSelected) return Colors.primary_50;
    return Colors.neutral_50;
  };

  const getBorder = () => {
    if (isSelected) return `2px solid ${Colors.secondary_500}`;
    return `2px solid ${Colors.neutral_50}`;
  };

  const getBoxShadow = () => {
    if (!isSelected && isHovered) {
      return '0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 2px 6px 2px rgba(0, 0, 0, 0.15)';
    }
    return 'none';
  };

  return (
    <Column
      data-testid="profession-type-card"
      alignItems="center"
      justifyContent="center"
      gap={8}
      onClick={onClick}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        width: 96,
        height: 132,
        borderRadius: 8,
        backgroundColor: getBackgroundColor(),
        border: getBorder(),
        boxShadow: getBoxShadow(),
        transform: !isSelected && isHovered ? 'scale(1.08)' : 'scale(1)',
        cursor: 'pointer',
        transition: 'box-shadow 0.2s ease, transform 0.2s ease',
      }}
    >
      <Icon />
      <Text
        fontSize={15}
        color={isSelected ? 'neutral_600' : 'neutral_500'}
        textAlign="center"
        style={{ fontFamily: 'Nunito', lineHeight: 1.2, width: 68 }}
      >
        {label}
      </Text>
    </Column>
  );
};
